module.exports = __webpack_public_path__ + "img/icon-notification.c5832b8b.svg";